import * as React from "react";
import { Search } from "lucide-react";
import { Link } from "react-router-dom";
import { CatalogCta, CatalogHero, CatalogLayout, ProductGrid } from "../components/catalog";
import { PRODUCT_GROUPS, getProduct } from "../data/products";

export function ProductsPage() {
  const [e, t] = React.useState("All products");
  const [n, r] = React.useState("");
  const i = (o) => `${o.name} ${o.subtitle} ${o.category}`.toLowerCase().includes(n.trim().toLowerCase());
  return (
    <CatalogLayout
      title="Products"
      description="Explore Actrium capture devices, tactile sensing and Atlas robot learning platforms."
    >
      <CatalogHero
        label="Hardware / Research systems"
        title="Products"
        intro="Build your system from visual-inertial capture, tactile sensing and robot learning hardware. Compare specifications, configuration options and development status."
      />
      <section className="catalog-wrap catalog-section catalog-first">
        <label className="product-search">
          <Search size={22} />
          <input
            type="search"
            aria-label="Search products"
            placeholder="Search products or applications"
            value={n}
            onChange={(o) => r(o.target.value)}
          />
        </label>
        <div className="catalog-filters" role="group" aria-label="Product category">
          {["All products", "Capture", "Robotics"].map((o) => (
            <button aria-pressed={e === o} onClick={() => t(o)} key={o}>
              {o}
            </button>
          ))}
        </div>
        {PRODUCT_GROUPS.filter(
          (o) =>
            e === "All products" ||
            (e === "Robotics" ? o.name === "Atlas Robotics" : o.name !== "Atlas Robotics"),
        )
          .filter((o) => o.slugs.some((s) => i(getProduct(s))))
          .map((o) => (
            <section className="catalog-group" key={o.name}>
              <div className="catalog-section-head">
                <h2>{o.name}</h2>
                {o.path && (
                  <Link className="catalog-text-link" to={o.path}>
                    Compare the series →
                  </Link>
                )}
              </div>
              <ProductGrid products={o.slugs.map((s) => getProduct(s)).filter(i)} />
            </section>
          ))}
        {!PRODUCT_GROUPS.filter(
          (o) =>
            e === "All products" ||
            (e === "Robotics" ? o.name === "Atlas Robotics" : o.name !== "Atlas Robotics"),
        ).some((o) => o.slugs.some((s) => i(getProduct(s)))) && (
          <p role="status">No products match your search. Try a product name or another category.</p>
        )}
      </section>
      <CatalogCta />
    </CatalogLayout>
  );
}
